export default __webpack_public_path__ + "static/Graphik-Regular-Web-63ffbe54183052f6c89340c8a85f28a9.woff";